module.exports = __webpack_public_path__ + "static/media/nishant arora resume.f47be362.pdf";